import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const KEY = "musas_mx_age_verified";

export default function AgeGate() {
  const { t } = useTranslation();
  const [shown, setShown] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem(KEY);
    if (!ok) setShown(true);
  }, []);

  if (!shown) return null;

  const accept = () => {
    if (!accepted) return;
    localStorage.setItem(KEY, "1");
    setShown(false);
  };

  const reject = () => { window.location.href = "https://www.google.com/"; };

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center p-4"
      style={{
        background: "rgba(8,7,8,0.92)",
        backdropFilter: "blur(12px)",
        backgroundImage: "url('https://images.unsplash.com/photo-1760421130990-928037a1af03?w=1600&q=60')",
        backgroundSize: "cover",
        backgroundBlendMode: "overlay",
      }}
      data-testid="age-gate-modal"
    >
      <div
        className="fade-up w-full max-w-lg p-10 text-center flex flex-col items-center gap-5"
        style={{
          background: "rgba(20,19,18,0.95)",
          border: "1px solid rgba(201,168,124,0.25)",
          boxShadow: "0 0 60px rgba(201,168,124,0.08)",
        }}
      >
        <div className="overline" data-testid="age-gate-overline">{t("agegate.overline")}</div>
        <span className="pk2-logo-glow is-large">
          <img src="/logo.png" alt="PK2 Scarlett" style={{ maxHeight: "120px", width: "auto" }} />
        </span>
        <div className="divider-ornament w-full">✦</div>
        <p className="text-sm md:text-base" style={{ color: "var(--text-secondary)", lineHeight: 1.7 }}>
          {t("agegate.headline")}
        </p>
        <p className="text-xs" style={{ color: "var(--text-muted)" }}>
          {t("agegate.disclaimer")}
        </p>
        <label
          className="flex items-start gap-3 p-3 cursor-pointer text-left w-full"
          style={{
            background: "rgba(8,7,8,0.6)",
            border: `1px solid ${accepted ? "var(--brand-primary)" : "rgba(255,255,255,0.12)"}`,
          }}
          data-testid="age-gate-terms-wrap"
        >
          <input
            type="checkbox"
            className="mt-1"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            style={{ accentColor: "var(--brand-primary)", width: 18, height: 18, flexShrink: 0 }}
            data-testid="age-gate-terms-checkbox"
          />
          <span className="text-xs" style={{ color: "var(--text-secondary)", lineHeight: 1.6 }}>
            {t("agegate.consent_pre")} <strong style={{ color: "var(--brand-primary)" }}>{t("agegate.consent_age")}</strong> {t("agegate.consent_and_accept")}{" "}
            <a href="/terminos" target="_blank" rel="noreferrer" style={{ color: "var(--brand-primary)", textDecoration: "underline" }}>
              {t("agegate.terms")}
            </a>{" "}
            {t("agegate.and_the")}{" "}
            <a href="/privacidad" target="_blank" rel="noreferrer" style={{ color: "var(--brand-primary)", textDecoration: "underline" }}>
              {t("agegate.privacy")}
            </a>.
          </span>
        </label>
        <div className="flex flex-col sm:flex-row gap-3 w-full mt-2">
          <button
            onClick={accept}
            className="btn-primary flex-1"
            disabled={!accepted}
            data-testid="age-gate-accept"
            style={!accepted ? { opacity: 0.4, cursor: "not-allowed" } : undefined}
          >
            {t("agegate.enter_btn")}
          </button>
          <button onClick={reject} className="btn-ghost flex-1" data-testid="age-gate-reject">
            {t("agegate.exit_btn")}
          </button>
        </div>
      </div>
    </div>
  );
}
